module.exports = __webpack_public_path__ + "img/economics.d58bee6d.svg";